<template>
  <div>
    <card v-if="spinning">
      <div class="row">
        <div class="col-sm-12 text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </card>
    <card>
      <div slot="header">
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-12">
                <h4 class="card-title">General Requirements Table</h4>
                <p class="card-category">Create or Edit General Requirements</p>
                <p class="card-category">
                  <el-button type="primary" @click="openModal('create')" icon="">Add New General Requirements</el-button>
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row align-items-center">
              <div class="col-sm-8" style="padding-right: 0;"> <!-- Remove padding if needed -->
                <el-input v-model="search" placeholder="Search" @keyup.native.enter="filteredGenerals"></el-input>
              </div>
              <div class="col-sm-4" style="padding-left: 5px;"> <!-- Minimal padding for spacing -->
                <el-button type="primary" @click="filterGenerals" icon="">Search</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="techTable" style="width: 100%">
        <el-table stripe :data="filteredGenerals" style="width: 100%" height="65vh" @sort-change="handleSortChange">
          <el-table-column prop="order" sortable="custom" label="Order" :min-width="150" align="center">
            <template v-slot="scope">
              <div class="row">
                <div class="col-sm-4">
                  {{ scope.row.order }}
                </div>
                <div class="col-sm-4">
                  <el-button type="text" icon="el-icon-arrow-up" @click="moveUp(scope.$index)" />
                </div>
                <div class="col-sm-4">
                  <el-button type="text" icon="el-icon-arrow-down" @click="moveDown(scope.$index)" />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" sortable="custom" label="Info" :min-width="500" align="center">
            <template v-slot="scope">
              <div class="row">
                <div class="col-sm-6">
                  <el-input placeholder="Name" v-model="scope.row.name" @change="updateGenerals(scope.row.id)"></el-input>
                </div>
                <div class="col-sm-6">
                  <el-input placeholder="Description" v-model="scope.row.description" @change="updateGenerals(scope.row.id)"></el-input>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Poom/Dan" :min-width="100" align="center">
            <template v-slot="scope">
              <el-select filterable v-model="scope.row.poom_dan_id" placeholder="Poom or Dan" style="width: 100%"
                         @change="updateGenerals(scope.row.id)">
                <el-option v-for="item in poomDan"
                           :key="item.id" :value="item.id" :label="item.name">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="pdf"  label="PDF" :min-width="200" align="center">
            <template v-slot="scope">
              <div v-if="scope.row.pdf">
                <el-button type="primary" @click="downloadPDF(scope.row.pdf, 'generals', scope.row.id)" icon="">{{ scope.row.pdf }}</el-button>
                <el-button type="danger" @click="removeFile(scope.row.id)" icon="el-icon-delete"></el-button>
              </div>
              <div v-else>
                <el-button type="primary" @click="preUpload('pdf', scope.row.id)" icon="">Upload PDF</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="url"  label="URL" :min-width="200" align="center">
            <template v-slot="scope">
              <el-input placeholder="Media URL" v-model="scope.row.media" style="width: 100%" @change="updateGenerals(scope.row.id)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template v-slot="scope">
              <el-button type="danger" @click="deleteGenerals(scope.row.id)" icon="el-icon-delete"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </card>
    <el-dialog
      center
      title="Error"
      :visible.sync="modals.error">
      <div class="text-center">
        <span>Error: {{ error_txt }}</span>
        <br>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="closeModal('error')" icon="OK"></el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Success"
      :visible.sync="modals.success">
      <div class="text-center">
        <span>{{ success_txt }}</span>
        <br>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="closeModal('success')" icon="">OK</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Upload PDF"
      :visible.sync="modals.pdf">
      <div class="text-center">
        <div class="row">
          <div class="col-sm-12">
            <input type="file" ref="pdfInput" @change="uploadPDF"/>
            <el-button type="primary" @click="uploadFile" icon="">Upload</el-button>
            <p v-if="message">{{ message }}</p>
          </div>
        </div>
        <br>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="closeModal('pdf')" icon="">Cancel</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Create New General Requirements"
      :visible.sync="modals.create">
      <div class="text-center">
        <div class="row">
          <div class="col-sm-4">
            <label>Name:</label>
              <el-input placeholder="Name" v-model="name"></el-input>
          </div>
          <div class="col-sm-4">
            <label>Description:</label>
            <el-input placeholder="Description" v-model="description"></el-input>
          </div>
          <div class="col-sm-4">
            <label>URL:</label>
            <el-input placeholder="Media URL" v-model="media"></el-input>
          </div>
        </div>
        <br>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="createGenerals('create')" icon="">OK</el-button>
          <el-button type="danger" @click="closeModal('create')" icon="">Cancel</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { Dialog, Button, Input, Checkbox, Table, TableColumn, Select, Option } from 'element-ui';
import GeneralsAPIService from "src/servicehandlers/GeneralsAPIService";
import { FileAPIService } from 'src/servicehandlers/FileHandler';
import PoomDanAPIService from "../../../../servicehandlers/PoomDanAPIService";

const generalsAPIService = new GeneralsAPIService();
const fileAPI = new FileAPIService();
const poomDanAPIService = new PoomDanAPIService();

export default {
  name: "GeneralRequirementsAdmin",
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Input.name]: Input,
    [Checkbox.name]: Checkbox,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      spinning: false,
      selected_generals_id: null,
      pdfFile: null,
      korean_name: null,
      tested: null,
      notes: null,
      taeguk_number: null,
      message: '',
      filename: null,
      name: null,
      description: null,
      pdf: null,
      media: null,
      last_order: null,
      generals: [],
      filteredGenerals: [],
      mediaFile: null,
      error_txt: null,
      success_txt: null,
      generals_list2: [],
      ranks: [],
      techniques: [],
      show_generals_ranks: false,
      show_generals_techniques: false,
      modals: {
        error: false,
        success: false,
        person: false,
        create: false,
        pdf: false,
        media: false
      },
      search: '',
      poomDan: []
    }
  },
  mounted() {
    this.getGenerals();
    this.getPoomDan()
  },
  methods: {
    getPoomDan(){
      return poomDanAPIService.getPoomDan(this.$router)
        .then(response => {
          this.poomDan = response
        })
    },
    async downloadPDF(name, type, id) {
      this.filename = name;
      this.spinning = true;
      return fileAPI.getPDFFile(name, type, id, this.$router)
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = this.filename;
        this.spinning = false;
        link.click();
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'General Requirements PDF download failed! ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['success'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      })
    },
    preUpload(name, id) {
      this.selected_generals_id = id;
      this.openModal(name);
    },
    removeFile(id) {
      const parms = {
        pdf: null,
      };
      return generalsAPIService.updateGenerals(id, parms, this.$router)
      .then(() => {
        this.getGenerals();
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'PDF clearing failure: ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['error'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      });
    },
    uploadFile() {
      this.spinning = true;
      this.files = this.$refs.pdfInput.files[0];
      let formData = new FormData();
      for (const fle of this.$refs.pdfInput.files) {
        formData.append('pdfInput', fle);
        formData.append('type', 'generals');
        formData.append('id', this.selected_generals_id);
      }
      return fileAPI.uploadFile(formData, this.$router)
      .then((response) => {
        const self = this;
        this.success_txt = 'PDF upload success';
        this.spinning = false;
        this.pdfFile = null;
        this.closeModal('pdf');
        this.openModal('success');
        this.getGenerals();
        setTimeout(function () {
          self.modals['success'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'File upload error: ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['error'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      });
    },
    uploadPDF(event) {
      const files = event.target.files;
      if (files.length > 0) {
        const fileType = /pdf/;
        if (!fileType.test(files[0].type)) {
          this.message = "Please select a valid PDF file.";
          return;
        }
        this.pdfFile = files[0];
        this.message = '';
      }
    },
    onEnd() {
      // go through all the order numbers, align with the indexes
      const promises = [];
      for (let i = 0; i < this.generals.length; i += 1) {
        const id = this.generals[i].id;
        this.generals[i].order = i + 1;
        promises.push(generalsAPIService.updateGenerals(id, { order: i + 1 }, this.$router));
      }
      return Promise.all(promises)
      // now start updating both the old index and the new to the new values
      .then(() => {
        this.getGenerals();
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'File upload error: ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['error'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      });
    },
    updateGenerals(id) {
      for (const poom of this.generals) {
        if (id === poom.id) {
          return generalsAPIService.updateGenerals(id, poom, this.$router)
          .then(() => {
            const self = this;
            this.success_txt = 'General Requirements update successful';
            /*this.openModal('success');
            setTimeout(function () {
              self.modals['success'] = false; // Use your variable name
            }, 1500); // Hide after 5 secs*/
          })
          .catch((error) => {
            const self = this;
            this.error_txt = 'General Requirements update failure: ' + error;
            this.openModal('error');
            this.spinning = false;
            setTimeout(function () {
              self.modals['error'] = false; // Use your variable name
            }, 1500); // Hide after 5 secs
          });
        }
      }
    },
    openModal(name) {
      this.modals[name] = true
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    deleteGenerals(id) {
      return generalsAPIService.deleteGenerals(id, this.$router)
      .then(() => {
        const self = this;
        this.success_txt = 'Delete General Requirements successful';
        this.openModal('success');
        setTimeout(function () {
          self.modals['success'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
        this.getGenerals();
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'Error deleting General Requirements: ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['error'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      });
    },
    getGenerals() {
      return generalsAPIService.getGenerals(this.$router)
      .then((response) => {
        for (const poom of response) {
          this.last_order = poom.order;
        }
        for (const poom of response) {
          this.generals_list2.push(poom);
        }
        this.generals = response;
        this.filteredGenerals = this.generals
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'Error getting General Requirements: ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['error'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      });
    },
    createGenerals() {
      this.closeModal('create');
      let order;
      if (this.last_order) {
        order = this.last_order;
        order += 1;
        this.last_order = order;
      } else {
        order = 1;
        this.last_order = 1;
      }
      const generals = {
        order,
        name: this.name,
        description: this.description,
        media: this.media,
      };
      return generalsAPIService.addGenerals(generals, this.$router)
      .then((response) => {
        this.generals.push(response);
        this.name = null;
        this.description = null;
        this.media = null;
        const self = this;
        this.getGenerals()
        this.success_txt = 'Add General Requirements successful';
        this.openModal('success');
        setTimeout(function () {
          self.modals['success'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      })
      .catch((error) => {
        const self = this;
        this.error_txt = 'Error Creating General Requirements: ' + error;
        this.openModal('error');
        this.spinning = false;
        setTimeout(function () {
          self.modals['error'] = false; // Use your variable name
        }, 1500); // Hide after 5 secs
      });
    },
    moveUp(index) {
      if (index > 0) {
        const temp = this.generals[index];
        this.generals.splice(index, 1);
        this.generals.splice(index - 1, 0, temp);
        this.updateOrder(temp)
      }
      this.onEnd();
    },
    moveDown(index) {
      if (index < this.generals.length - 1) {
        const temp = this.generals[index];
        this.generals.splice(index, 1);
        this.generals.splice(index + 1, 0, temp)
        this.updateOrder(temp)
      }
      this.onEnd();
    },
    updateOrder(item){
      for (let i = 0; i < this.generals.length; i++){
        this.generals[i].order = i+1
      }
      this.updateGenerals(item.id)
    },
    handleSortChange({ column, prop, order}) {
      if (order === "ascending") {
        this.filteredGenerals.sort((a, b) => (a[prop] > b[prop] ? 1 : -1));
      } else if (order === "descending") {
        this.filteredGenerals.sort((a, b) => (a[prop] < b[prop] ? 1 : -1));
      }
    },
    filterGenerals(){
      try {
        this.filteredGenerals = this.generals.filter(
          (data) =>
            !this.search ||
            data.name.toLowerCase().includes(this.search.toLowerCase())
        )
      } catch (e) {
        this.error_txt = 'One or more names missing'
        this.openModal('error')
      }
    },
  }
}
</script>

<style scoped>
el-input{
  width: 100%;
}
</style>
